import { AttendeeModel, AttendeeModelFromJson, ODataAttendeeOutModel } from '../complex/attendee.model';
import { ArrayModel, JsonArrayModel, ArrayModelFromJson } from '../complex/array.model';
import { CompositeModel } from '../complex/composite.model';
import { ODataObject } from '../../interfaces/odata-model.interface';

export class ConfirmationAttendeesModel extends CompositeModel {
    public attendeeList: ArrayModel<AttendeeModel>;
    public constructor() {
        super('ConfirmationAttendeesModel');

        this.attendeeList = <ArrayModel<AttendeeModel>>this.set(new ArrayModel<AttendeeModel>('AttendanceSet'));
    }
}

export class ConfirmationAttendeesModelFromJson extends ConfirmationAttendeesModel {
    public constructor(data: JsonConfirmationAttendeesModel) {
        super();

        this.attendeeList = <ArrayModel<AttendeeModel>>(
            this.set(new ArrayModelFromJson(AttendeeModelFromJson, data.attendeeList))
        );
    }
}

export interface JsonConfirmationAttendeesModel {
    attendeeList: JsonArrayModel;
}

export interface ODataConfirmationAttendeesOutModel extends ODataObject {
    AttendanceSet: ODataAttendeeOutModel[];
}
